
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightFlashlightColourOn as ObiLightFlashlightColourOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-flashlight-colour-on.js';
 
 
 

 
 export const ObiLightFlashlightColourOn = createComponent({
   react: React,
   tagName: 'obi-light-flashlight-colour-on',
   elementClass: ObiLightFlashlightColourOnElement,
   events: {
     
   }
  });
 
 